;(function () {
    "use strict";

    $(document).ready(function() {

        var $root = $('.scrollable-wrap');

        if ($root.length > 0) {

            $root.each(function() {

                var $root      = $(this);
                var $inner     = $root.children();
                var $active    = $();
                var isOverflow = function() {

                    var innerWidth;

                    if ($inner.length < 2) {
                        innerWidth = $inner.outerWidth();
                    }
                    else {
                        innerWidth = _($inner).reduce(function(a, b) {
                            return (_(a).isNumber() ? a : $(a).outerWidth()) + $(b).outerWidth();
                        });
                    }

                    return innerWidth >= $root.width();
                };
                var calcScrollLeft      = function() { return $root.scrollLeft(); };
                var calcMaxScrollleft   = function() { return $inner.outerWidth(true) - $root.width(); };
                var maxScrollLeft       = calcMaxScrollleft();
                var noOverflowClass     = 'scrollable-wrap_no-overflow';
                var scrollToActiveClass = 'scrollable-wrap_scroll-to-active';
                var leftСlass           = 'scrollable-wrap_scrolled-to-the-left';
                var rightClass          = 'scrollable-wrap_scrolled-to-the-right';
                var storePositionLocal  = false;
                var storedId            = '';

                var storeScrollPosition = _.debounce(function (scrollLeft) {
                    $.jStorage.set(storedId, scrollLeft, 1000 * 60 * 60);
                }, 200);

                var processOverflow = function() {

                    if (isOverflow()) {

                        maxScrollLeft = calcMaxScrollleft();
                        $root.removeClass(noOverflowClass);


                        if (storePositionLocal) {
                            $root.scrollLeft($.jStorage.get(storedId) || 0);
                        }

                        if ($active.length > 0 && !$active.is(':last-child')) {
                            var offsetLeft = $active.offset().left - $root.width() / 2  + $active.outerWidth() / 2;
                            $root.scrollLeft(offsetLeft);
                        }

                        if ($root.hasClass('scrollable-wrap_glue-to-right') || $active.is(':last-child')) {
                            $root.scrollLeft(99999);
                        }
                    }
                    else {

                        $root
                            .addClass(noOverflowClass)
                            .removeClass(leftСlass)
                            .removeClass(rightClass);
                    }

                    $root.trigger('scroll');
                };

                var processScroll = function() {

                    if (isOverflow()) {
                        var scrollLeft = calcScrollLeft();
                        $root.removeClass(leftСlass).removeClass(rightClass);

                        if (scrollLeft <= 6) {
                            $root.addClass(leftСlass);
                        }
                        if (scrollLeft >= maxScrollLeft - 6) {
                            $root.addClass(rightClass);
                        }

                        storeScrollPosition(scrollLeft);
                    }
                    else {
                        storeScrollPosition(0);
                    }
                };

                if ($root.is('[id]')) {
                    storePositionLocal = true;
                    storedId = $root.attr('id');
                }

                if ($root.is('.' + scrollToActiveClass)) {
                    $active = $root.find('.scrollable-wrap__active');
                }

                $(window).on('debouncedresize', processOverflow);
                $(document).on('ready', processOverflow);
                $root.on('scroll', processScroll);
            });
        }
    });
})();